var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row auctions artworks-list"},[_vm._l((_vm.artworks),function(artwork,index){return _c('ArtworkRow',{key:artwork.id,attrs:{"artwork":artwork,"index":index}})}),_vm._v(" "),_c('transition',{attrs:{"appear":""},on:{"beforeEnter":_vm.beforeEnterAnimation,"enter":_vm.enterAnimation,"leave":_vm.leaveAnimation}},[(_vm.currentArtworkIndex !== '')?_c('SearchResultsModal'):_vm._e()],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39f0cd2a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/packs/search_page/index/components/artworks_tab/artworks_list.vue
// module id = 665
// module chunks = 0 1 2 3 4 5 6 7 8 10 32 40 44 70